import { Injectable } from "@angular/core";
import { IUserRole } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalUserRoleService extends BaseService<IUserRole> {}
